export enum MonitorFilterActionType {
  UPDATE_FILTER = "[Monitor Filter] - Update Topic",
}

export type UpdateTopicsFilterAction = {
  payload: { selectedTopics?: string[] };
  type: MonitorFilterActionType.UPDATE_FILTER;
};
